module.exports = import("https://aiadmin-stg.pearson.com/assets/remoteEntry.js");